
import { LISTING_TYPE } from '~/constants/listing-types';
import TooltipIcon from '~/components/common/TooltipIcon.vue';
import OriginalsLogo from '~/static/originals.svg';
import SelectLogo from '~/static/appsumo-select.svg';
import PlusExclusiveLogo from '~/static/appsumo-plus-exclusive.svg';

export default {
  name: 'ListingTypeLogo',
  components: {
    TooltipIcon,
  },
  props: {
    publicName: {
      type: String,
      required: true,
    },
    listingType: {
      type: String,
      required: true,
    },
    tooltipId: {
      type: String,
      required: true,
    },
  },
  computed: {
    // make sure this is up to date with LISTING_TYPES_WITH_LOGO
    imgDetails() {
      if (this.listingType === LISTING_TYPE.ORIGINAL) {
        return [OriginalsLogo, 'AppSumo Originals Logo'];
      }
      if (this.listingType === LISTING_TYPE.SELECT) {
        return [SelectLogo, 'AppSumo Select Logo'];
      }
      if (this.listingType === LISTING_TYPE.PLUS_EXCLUSIVE) {
        return [PlusExclusiveLogo, 'AppSumo Plus Exclusive Logo'];
      }

      return null;
    },
    tooltipText() {
      if (this.listingType === LISTING_TYPE.SELECT) {
        return 'Exclusive offers on the hottest software, expertly tested, vetted, and brought to you by the AppSumo team.';
      }
      if (this.listingType === LISTING_TYPE.PLUS_EXCLUSIVE) {
        return `This is an exclusive version of ${this.publicName} only available to AppSumo Plus members. If you are not an AppSumo Plus member, you can join now and purchase this deal.`;
      }

      return null;
    },
  },
};
